import {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from "axios";
import { ErrorTransform, requestFactory } from "../utils/serviceHelper";

/**
 *
 * WSService wraps up our axios instances and tacks on some nice lil extras!
 */

export class WSService {
  serviceRoot = "";
  errorTransforms: ErrorTransform[] = [];
  requestFactory: AxiosInstance;

  constructor(serviceRoot: string, errorTransforms?: ErrorTransform[]) {
    this.serviceRoot = serviceRoot;
    if (errorTransforms && errorTransforms.length > 0) {
      this.errorTransforms.push(...errorTransforms);
    }
    this.requestFactory = requestFactory(
      this.serviceRoot,
      this.errorTransforms
    );
  }

  private handleError(err: AxiosError): Promise<AxiosResponse<any>> {
    throw err;
  }

  async get(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> {
    return this.requestFactory.get(url, config).catch(this.handleError);
  }

  async post(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> {
    return this.requestFactory.post(url, data, config).catch(this.handleError);
  }

  async patch(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> {
    return this.requestFactory.patch(url, data, config).catch(this.handleError);
  }

  async delete(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<any>> {
    return this.requestFactory.delete(url, config).catch(this.handleError);
  }
}
